<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Submit Working Hour</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Choose Campaign:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <CampaignAutocomplete
                :key="companySearchComponentKey"
                class="searchbox"
                :list="searchCampaign"
                :searchOn="'campaign'"
                @event-name="handleChildEvent"
              ></CampaignAutocomplete>
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-if="campaign_is_required"
              >{{ campaign_is_required }}</span
            >
            
        
          </div>
               <div class="vx-row mb-6" v-if="my_allocation && my_allocation.allocated_hours != null">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-alert active="true" :color="my_allocation.remaining_hours > 0 ? 'warning' : 'danger'"
                icon="schedule">
                You have {{ (my_allocation.remaining_hours / 7).toFixed(2) }} days
                ({{ my_allocation.remaining_hours }} h) remaining on this campaign ·
                window ends {{ formatAllocationEndDate(my_allocation.campaign_end_date) }}
              </vs-alert>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Working Hours :</span>
            </div>
            <div class="vx-col sm:w-1/6 xs:w-1/2 w-full">
              <flat-pickr
                class="flat-pick"
                :config="configdateTimePicker"
                v-model="working_hours.date"
                v-validate="'required'"
                name="date"
                data-vv-as="working date"
                placeholder="Choose working date"
              />
            </div>
            <div class="vx-col sm:w-1/6 xs:w-1/2 w-full">
              <flat-pickr
                :config="configTimePicker"
                v-model="working_hours.hours"
                v-validate="'required'"
                name="hours"
                data-vv-as="working hours"
                placeholder="Choose total hours"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('date')"
              >{{ errors.first("date") }}</span
            >
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('hours')"
              >{{ errors.first("hours") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Comments:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-textarea name="comments" v-validate="'required'"  data-vv-as="Comments" v-model="working_hours.comments" />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('comments')"
              >{{ errors.first("comments") }}</span
            >
          </div>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
export default {
  data() {
    return {
      user_id: null,
    user_role: null,
      configdateTimePicker: {
        format: "d/m/Y",
        altFormat: "d/m/Y",
        altInput: true,
        maxDate: "today"
      },
      campaign_is_required: null,
      my_allocation: null,
      configTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H.i",
        time_24hr: true,
        minTime: "00:00",
        maxTime: "23:00"
      },
      companySearchComponentKey: 0,
      abilities: null,
      working_hours: {
        date: null,
        hours: null,
        comments: null,
        campaignId: null
      },
      previous_working_hours: null
    };
  },
  components: {
    CampaignAutocomplete,
    moduleCampaignManagement,
    flatPickr
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (this.user_role == 'Client Administrator' || this.user_role == 'Client'){
      this.$router.replace("/unauthorized")
    }
    var self = this;

    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  },
  mounted() {},
  methods: {
    restrictSubmit() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Submit Hours`,
        text:
          "You have submitted more than 7 hours.  Please complete comments to explain the additional hours claimed.When submitting more than 7 hours, an explanation for the additional time needs to be submitted too.",
        accept: this.accept,
        acceptText: "Ok"
      });
    },
    alertUpdate() {
      this.showPreviousWorkingHours();

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Update Working Hour`,
        text: "Are you sure you want to change the hours of this date?",
        accept: this.update,
        acceptText: "Ok"
      });
    },
    accept() {
      return false;
    },
    updateWorkingHours() {
           this.$vs.loading();

      this.working_hours.user_role = this.user_role;
      this.working_hours.submit_type = 'Updated Hours';
      this.$store
        .dispatch("campaignsManagement/updateWorkingHours", this.working_hours)
        .then(res => {


                   // D6: allocation hard block — must be checked before every other status branch
          if (res.data.status == "allocation_exceeded") {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "danger",
              title: "Allocation limit reached",
              text: res.data.message,
              time: 10000
            });
            this.fetchMyAllocation();
            return false;
          }


          if (res.data.status == "fail") {
            this.alertUpdate();
          } else {
            this.$vs.notify({
              color: "success",
              title: "Submit Hours",
              text: "The submit hours was updated successfully"
            });
            this.$vs.loading.close();
            this.$router.go()
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    showPreviousWorkingHours() {
      var self = this;
      this.$store
        .dispatch(
          "campaignsManagement/showPreviousWorkingHours",
          this.working_hours
        )
        .then(res => {
          let result = res.data;
          self.previous_working_hours = result;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    update() {
      this.$validator.validateAll().then(result => {
        this.working_hours.user_id = this.user_id;
        
        this.working_hours.previous_hour = this.previous_working_hours.hours;
        

        if (this.working_hours.campaignId == null) {
          this.campaign_is_required = "The campaign field is required.";
          result = false;
          return false;
        } else {
          result = true;
          this.working_hours.date = moment(this.working_hours.date).format(
            "YYYY-MM-DD"
          );
        }

        if (this.working_hours.hours) {
          let total_working_hours = this.working_hours.hours
            .split(".")
            .join("");
          if (
            parseInt(total_working_hours, 10) > 700 &&
            this.working_hours.comments == null
          ) {
            this.restrictSubmit();
          } else {
            this.updateWorkingHours();
          }
        }
      });
    },
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchWithCampaignOnly", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                } 
                // else {
                //   mappedArray.push({
                //     id: data[property].id,
                //     name: data[property].company_name + " (Client)",
                //     type: "client"
                //   });
                // }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    handleChildEvent() {
      this.working_hours.campaignId =
        moduleCampaignManagement.state.campaign.datas[0].id;
      this.fetchMyAllocation();
    },
    fetchMyAllocation() {
      var self = this;
      self.my_allocation = null;
      this.$store
        .dispatch(
          "campaignsManagement/getMySdAllocation",
          this.working_hours.campaignId
        )
        .then(res => {
          self.my_allocation = res.data.data;
        })
        .catch(err => {
          self.my_allocation = null;
          if (err.response && err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    formatAllocationEndDate(value) {
      if (!value) return "";
      if (typeof value === "string" && /^\d{2}-\d{2}-\d{4}$/.test(value)) {
        return moment(value, "DD-MM-YYYY").format("DD MMM YYYY");
      }
      var m = moment(value);
      return m.isValid() ? m.format("DD MMM YYYY") : String(value);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {

         if(!result){
            return false
         }

        if (this.working_hours.campaignId == null) {
          this.campaign_is_required = "The campaign field is required.";
          result = false;
          return false;
        } else {
          result = true;
          this.working_hours.date = moment(this.working_hours.date).format(
            "YYYY-MM-DD"
          );
        }

        if (this.working_hours.hours) {
          let total_working_hours = this.working_hours.hours
            .split(".")
            .join("");
          if (
            parseInt(total_working_hours, 10) > 700 &&
            this.working_hours.comments == null
          ) {
            this.restrictSubmit();
          } else {
            this.addWorkingHours();
          }
        }
      });
    },
    Exceed15hoursUpdateWorkingHours() {
      this.$vs.loading();

      this.working_hours.user_role = this.user_role;
      this.working_hours.previous_hour = this.working_hours.hours;
      this.working_hours.submit_type = 'Late submission of hours';


   




      this.$store
        .dispatch("campaignsManagement/Exceed15hoursUpdateWorkingHours", this.working_hours)
        .then(res => {


    // D6: allocation hard block — must be checked before every other status branch
          if (res.data.status == "allocation_exceeded") {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "danger",
              title: "Allocation limit reached",
              text: res.data.message,
              time: 10000
            });
            this.fetchMyAllocation();
            return false;
          }


          if (res.data.status == "fail") {
            this.alertUpdate();
          } else {
            this.$vs.notify({
              color: "success",
              title: "Submit Hours",
              text: "The submit hours was updated successfully"
            });
            this.$vs.loading.close();
            this.$router.go()
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    addWorkingHours() {



          this.$vs.loading();


      this.working_hours.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/addWorkingHours", this.working_hours)
        .then(res => {




          // D6: allocation hard block — must be checked before every other status branch
          if (res.data.status == "allocation_exceeded") {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "danger",
              title: "Allocation limit reached",
              text: res.data.message,
              time: 10000
            });
            this.fetchMyAllocation();
            return false;
          }
          
          // Submit time 15 hours has been reached
         if (res.data.status == "more_than_15_hours") {


          if (this.working_hours.comments == null) {


            this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Late submission of hours`,
        text: "Please complete comments to explain the late submission of hours.",
        acceptText: "Ok"
      });

          return false;
        }



            this.$vs.notify({
              color: "warning",
              title: "Submit Hours",
              text: "You are submitting hours for a day outside of its submission window.Your submission will be sent for review by your manager."
            });
            this.$vs.loading.close();
            this.Exceed15hoursUpdateWorkingHours();
            return false;
         }

        if (res.data.status == "update_hour_with_more_than_15_hours") {

  


            this.$vs.dialog({
              acceptText: "Ok",
              color: "danger",
              title: "Late submission of hours",
              text: "The hours you have submitted for on " + this.working_hours.date + " are outside of the normal submission window.  You cannot change these hours until your manager has approved the late submission. "
            });
            this.$vs.loading.close();
            return false;
         }


         if (res.data.status == "update_more_than_15_hours_after_approved_or_declined") {
          this.alertUpdate();
          this.$vs.loading.close();
          return false;
          }
         



          if (res.data.status == "already_submitted") {
            this.$vs.notify({
              color: "warning",
              title: "Submit Hours",
              text: "You have not made any updates."
            });
            return false;
          }
          else if (res.data.status == "more_than_7_hours") {
            this.restrictSubmit();
          } else if (res.data.status == "fail") {
            this.$vs.loading.close();
            this.alertUpdate();
          } else {
            this.$vs.notify({
              color: "success",
              title: "Submit Hours",
              text: "The submit hours was added successfully"
            });
            this.$vs.loading.close();


            this.$router.go()
          }
        })
        .catch(err => {
        console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  }
};
</script>
<style>
.flat-pick {
  padding: 0.7rem;
  font-size: 1rem;
  color: #626262;
  cursor: pointer;
}
</style>
<style scoped>
.removeButton {
  cursor: pointer;
}
</style>
